// Mirrors Whatsapp::TemplateNameSanitizer (Ruby) — used only to preview, in the form,
// what the backend will actually save as the template name once submitted for approval.
export const sanitizeTemplateName = name =>
  (name || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9_]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '');
